import { persistStore } from 'redux-persist';

import type { AppStore } from '../types';

export default function initPersistence(store: AppStore) {
  const persistor = persistStore(store);

  const purge = () => persistor.purge();

  // pause saving data
  const pause = () => persistor.pause();

  // start saving data
  const resume = () => persistor.persist();

  return {
    persistor,
    purge,
    pause,
    resume,
  };
}
